import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";
export var SelfServeProgressBar = function SelfServeProgressBar(_ref) {
  var progress = _ref.progress;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  return /*#__PURE__*/React.createElement(ProgressBarWrapper, null, /*#__PURE__*/React.createElement(Bar, {
    "$progress": Math.min(progress, 100),
    color: Core.surface["default"],
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": progress,
    "aria-valuetext": strictLocalize({
      id: "9Kj6fV",
      defaultMessage: [{
        "type": 1,
        "value": "progressNumber"
      }, {
        "type": 0,
        "value": " procent vooruitgang geboekt"
      }]
    }, {
      progressNumber: progress
    }),
    role: "progressbar"
  }));
};
var ProgressBarWrapper = styled(Row).attrs({
  align: "center"
}).withConfig({
  displayName: "SelfServeProgressBar__ProgressBarWrapper"
})(["height:", ";width:100%;"], getSpacing("2x"));
var Bar = styled.div.withConfig({
  displayName: "SelfServeProgressBar__Bar"
})(["position:relative;background-color:", ";height:6px;flex:1;&::before{content:\"\";position:absolute;inset-block-start:0;inset-inline-start:0;height:100%;width:", "%;background-color:", ";transition:width 0.4s cubic-bezier(0.7,-0.4,0.4,1.4);}"], Core.border.muted, function (_ref2) {
  var $progress = _ref2.$progress;
  return $progress;
}, Core.surface["default"]);